import React from 'react';
import { RadioCard, RadioCardItem } from '../RadioCard';
export const RadioOptionList = ({ name, options = [], defaultValue, control, value, px, py, fullWidth, noWrap, onChange, }) => {
    return (React.createElement(RadioCard, { name: name, value: value, defaultValue: defaultValue, px: px, py: py, fullWidth: fullWidth, noWrap: noWrap, onChange: value => {
            control.setValue(name, value);
            control.trigger(name);
            if (typeof onChange === 'function') {
                onChange(value);
            }
        } }, options.map((option, i) => (React.createElement(RadioCardItem, { key: option.value, id: `${name}-option-list-${i}`, label: option.label, value: option.value, ref: control.register() })))));
};
RadioOptionList.displayName = 'RadioOptionList';
//# sourceMappingURL=index.js.map